export enum AssignmentTypeEnum {
  GENERAL = 1,
  COMPLAINT = 2,
  INCIDENT = 3
}
